import {
    UserLogin,
    User,
    SearchResult,
    PortfolioCompany,
    CompanyOverview,
    CompanyRanking,
    EventItem,
    CompanySie,
    CompanyDocument,
    Version, UpdatedCompany,
} from './models';
import user from '@/store/modules/user';
import axios from 'axios';

// tslint:disable:max-line-length

const successHandler = (response: any) => {
    return response;
};

const errorHandler = (error: any) => {
    if (axios.isCancel(error)) {
        return Promise.reject(error);
    }
    console.log('API ERROR:', error.response.status, error.response.data);
    if (error.response.status === 401) {
        // user.reset();
        if (error.response.data.URL) {
            window.location = error.response.data.URL;
        }
    }
    return Promise.reject({ error });
};

axios.interceptors.response.use(
    (response: any) => successHandler(response),
    (error: any) => errorHandler(error),
);

axios.interceptors.request.use((config) => {
    // console.log('AXIOS', config);
    return config;
});

axios.defaults.withCredentials = true;

export async function login(userLogin: UserLogin) {
    try {
        await axios.post('/api/login', userLogin);
        // await getUser();
    } catch (error) {
        // TODO
        alert('Misslyckad inloggning, försök igen!');
        console.log(error);
    }
}

export async function logout() {
    try {
        await axios.get('/api/logout');
        // tslint:disable-next-line:no-empty
    } catch (error) {}
}

export async function getVersion(): Promise<Version | null> {
    try {
        return (await axios.get('/api/version')).data;
    } catch (error) {
        return null;
    }
}

export async function getUser(): Promise<User | null> {
    try {
        return (await axios.get('/api/user')).data;
    } catch (error) {
        return null;
    }
}

export async function getUsers(): Promise<User[] | null> {
    try {
        return (await axios.get('/api/user/users')).data;
    } catch (error) {
        return null;
    }
}

export async function addCompany(orgNr: string) {
    try {
        return (await axios.put(`/api/user/companies/${orgNr}`)).data;
    } catch (error) {
        return null;
    }
}

export async function updateCompany(orgNr: string): Promise<boolean> {
    try {
        return (await axios.get(`/api/user/0/companies/${orgNr}/update`)).data;
    } catch (error) {
        return false;
    }
}

export async function getCompany(version: number, orgNr: string): Promise<PortfolioCompany | null> {
    try {
        return (await axios.get(`/api/user/${version}/companies/${orgNr}`)).data;
    } catch (error) {
        return null;
    }
}

export async function getCompanies(version: number): Promise<PortfolioCompany[] | null> {
    try {
        return (await axios.get(`/api/user/${version}/companies`)).data;
    } catch (error) {
        return null;
    }
}

export async function getEvents(version: number): Promise<EventItem[] | null> {
    try {
        return (await axios.get(`/api/user/${version}/events`)).data;
    } catch (error) {
        return null;
    }
}

export async function getUpdates(): Promise<UpdatedCompany[] | null> {
    try {
        return (await axios.get(`/api/user/updates`)).data;
    } catch (error) {
        return null;
    }
}

export async function getOverview(version: number, orgNr: string | null): Promise<CompanyOverview | undefined> {
    try {
        return (await axios.get(`/api/user/${version}/companies/${orgNr}/overview`)).data;
    } catch (error) {
        return undefined;
    }
}

export async function getRanking(version: number, orgNr: string | null): Promise<any | undefined> {
    try {
        return (await axios.get(`/api/user/${version}/companies/${orgNr}/ranking`)).data;
    } catch (error) {
        return undefined;
    }
}

export async function getIndustryRanking(industry: string | null): Promise<any | undefined> {
    try {
        return (await axios.get(`/api/industry/${industry}/ranking`)).data;
    } catch (error) {
        return undefined;
    }
}

export async function getRankingSie(version: number, orgNr: string | null): Promise<any | undefined> {
    try {
        return (await axios.get(`/api/user/${version}/companies/${orgNr}/ranking/sie`)).data;
    } catch (error) {
        return undefined;
    }
}

export async function getBalance(version: number, orgNr: string | null): Promise<any | undefined> {
    try {
        return (await axios.get(`/api/user/${version}/companies/${orgNr}/balance`)).data;
    } catch (error) {
        return undefined;
    }
}

export async function getBalanceSie(version: number, orgNr: string | null): Promise<any | undefined> {
    try {
        return (await axios.get(`/api/user/${version}/companies/${orgNr}/balance/sie`)).data;
    } catch (error) {
        return undefined;
    }
}

export async function getProfitLoss(version: number, orgNr: string | null): Promise<any | undefined> {
    try {
        return (await axios.get(`/api/user/${version}/companies/${orgNr}/profitloss`)).data;
    } catch (error) {
        return undefined;
    }
}

export async function getProfitLossSie(version: number, orgNr: string | null): Promise<any | undefined> {
    try {
        return (await axios.get(`/api/user/${version}/companies/${orgNr}/profitloss/sie`)).data;
    } catch (error) {
        return undefined;
    }
}

export async function getCashFlow(version: number, orgNr: string | null): Promise<any | undefined> {
    try {
        return (await axios.get(`/api/user/${version}/companies/${orgNr}/cashflow`)).data;
    } catch (error) {
        return undefined;
    }
}

export async function getCashFlowSie(version: number, orgNr: string | null): Promise<any | undefined> {
    try {
        return (await axios.get(`/api/user/${version}/companies/${orgNr}/cashflow/sie`)).data;
    } catch (error) {
        return undefined;
    }
}

export async function getSustainability(version: number, orgNr: string | null): Promise<any | undefined> {
    try {
        return (await axios.get(`/api/user/${version}/companies/${orgNr}/sustainability`)).data;
    } catch (error) {
        return undefined;
    }
}

export async function getValuation(offset: number, version: number, orgNr: string | null): Promise<any | undefined> {
    try {
        return (await axios.get(`/api/user/${version}/companies/${orgNr}/valuation/${offset}`)).data;
    } catch (error) {
        return undefined;
    }
}

export async function getValuationSie(offset: number, version: number, orgNr: string | null): Promise<any | undefined> {
    try {
        return (await axios.get(`/api/user/${version}/companies/${orgNr}/valuation/${offset}/sie`)).data;
    } catch (error) {
        return undefined;
    }
}

export async function getSies(version: number, orgNr: string | null): Promise<CompanySie[] | undefined> {
    try {
        return (await axios.get(`/api/user/${version}/companies/${orgNr}/sie`)).data;
    } catch (error) {
        return undefined;
    }
}

export async function getDocuments(version: number, orgNr: string | null): Promise<CompanyDocument[] | undefined> {
    try {
        return (await axios.get(`/api/user/${version}/companies/${orgNr}/document`)).data;
    } catch (error) {
        return undefined;
    }
}

export async function getTemplates(): Promise<CompanyDocument[] | null> {
    try {
        return (await axios.get(`/api/user/templates`)).data;
    } catch (error) {
        return null;
    }
}

export async function getTemplate(templateId: string): Promise<any[] | null> {
    try {
        return (await axios.get(`/api/user/templates/${templateId}`)).data;
    } catch (error) {
        return null;
    }
}

export async function getDocument(documentId: string, internal: boolean = false): Promise<any | undefined> {
    try {
        if (internal) {
            return (await axios.get(`/admin/document/${documentId}`)).data;
        } else {
            return (await axios.get(`/api/user/document/${documentId}`)).data;
        }
    } catch (error) {
        return undefined;
    }
}

export async function getSharedDocument(documentId: string): Promise<any | undefined> {
    try {
        return (await axios.get(`/api/shared/${documentId}`)).data;
    } catch (error) {
        return undefined;
    }
}

export async function getSharedDocumentInfo(documentId: string): Promise<any | undefined> {
    try {
        return (await axios.get(`/api/shared/${documentId}/info`)).data;
    } catch (error) {
        return undefined;
    }
}

export async function getWebreport(documentId: string): Promise<any | undefined> {
    try {
        return (await axios.get(`/api/webreport/${documentId}`)).data;
    } catch (error) {
        return undefined;
    }
}

export async function getQuick(userId: string, version: number, orgNr: string, sieId: number, internal: boolean = false): Promise<any | undefined> {
    try {
        if (internal) {
            return (await axios.get(`/admin/quick/${userId}/${version}/${orgNr}/${sieId}`)).data;
        } else {
            return (await axios.get(`/api/users/${userId}/${version}/quick/${orgNr}/${sieId}`)).data;
        }
    } catch (error) {
        return undefined;
    }
}

export async function getDocumentInternal(documentId: string): Promise<any | undefined> {
    try {
        return (await axios.get(`/admin/document/${documentId}`)).data;
    } catch (error) {
        return undefined;
    }
}

export async function deleteDocument(documentId: string): Promise<any | undefined> {
    try {
        return (await axios.delete(`/api/user/document/${documentId}`)).data;
    } catch (error) {
        return undefined;
    }
}

export async function updateDocumentComments(comments: any): Promise<any | undefined> {
    try {
        return (await axios.post(`/api/user/document/comments`, comments)).data;
    } catch (error) {
        return undefined;
    }
}

export async function updateDocumentItem(documentId: string, item: any): Promise<any | undefined> {
    try {
        return (await axios.post(`/api/user/document/${documentId}/item`, item)).data;
    } catch (error) {
        return undefined;
    }
}

export async function getDocumentComments(documentId: string): Promise<any | undefined> {
    try {
        return (await axios.get(`/api/user/document/${documentId}/comments`)).data;
    } catch (error) {
        return undefined;
    }
}

export async function getDocumentPlain(documentId: string): Promise<any | undefined> {
    try {
        return (await axios.get(`/api/user/documentplain/${documentId}`)).data;
    } catch (error) {
        return undefined;
    }
}

export async function getSie(sieId: string): Promise<any | undefined> {
    try {
        return (await axios.get(`/api/user/sie/${sieId}`)).data;
    } catch (error) {
        return undefined;
    }
}

export async function deleteSie(sieId: string): Promise<any | undefined> {
    try {
        return (await axios.delete(`/api/user/sie/${sieId}`)).data;
    } catch (error) {
        return undefined;
    }
}

export async function searchCompanies(phrase: string): Promise<SearchResult | null> {
    try {
        // TODO: handle input
        return (await axios.post(`/api/search`, phrase)).data;
    } catch (error) {
        return null;
    }
}

export async function ticSearchCompany(orgNr: string): Promise<any | undefined> {
    try {
        return (await axios.get(`/api/tic/search/${encodeURIComponent(orgNr)}`)).data;
    } catch (error) {
        return undefined;
    }
}

export async function ticGetCompanyWebsite(orgNr: string): Promise<string> {
    try {
        const data = (await axios.get(`/api/ai/company/${encodeURIComponent(orgNr)}/website`)).data;
        if (data && typeof data.website === 'string') {
            return data.website;
        }
        return '';
    } catch (error) {
        return '';
    }
}

export async function ticGetInsights(orgNr: string): Promise<any | null | undefined> {
    try {
        const res = await axios.get(`/api/ai/company/${encodeURIComponent(orgNr)}/insights`);
        if (res.status === 204 || !res.data) {
            return null;
        }
        if (res.data.generating === true) {
            return {
                generating: true,
                started_at: typeof res.data.started_at === 'string' ? res.data.started_at : undefined,
            };
        }
        return res.data;
    } catch (error) {
        return undefined;
    }
}

export async function ticGenerateInsights(
    orgNr: string,
    cancelToken?: import('axios').CancelToken,
    website?: string,
): Promise<any> {
    try {
        const params = website !== undefined ? { website } : undefined;
        return (
            await axios.post(
                `/api/ai/company/${encodeURIComponent(orgNr)}/insights`,
                {},
                { cancelToken, params },
            )
        ).data;
    } catch (error) {
        if (axios.isCancel(error)) {
            throw error;
        }
        return undefined;
    }
}

export async function ticContinueInsights(orgNr: string): Promise<any | null> {
    try {
        return (
            await axios.put(`/api/ai/company/${encodeURIComponent(orgNr)}/insights`, {
                continue: true,
            })
        ).data;
    } catch (error) {
        return null;
    }
}

export async function ticRegenerateInsightQuestion(
    orgNr: string,
    body: {
        website?: string;
        keep: any[];
        replace: any;
        rejected?: string[];
        company_summary?: string;
        industry_summary?: string;
        webpage_analysis?: string;
    },
    cancelToken?: import('axios').CancelToken,
): Promise<any> {
    try {
        return (
            await axios.post(
                `/api/ai/company/${encodeURIComponent(orgNr)}/insights/regenerate`,
                body,
                { cancelToken },
            )
        ).data;
    } catch (error) {
        if (axios.isCancel(error)) {
            throw error;
        }
        return undefined;
    }
}

export async function ticGetFinancialReportFile(
    companyId: number,
    summaryId: number,
    fileId: number,
): Promise<ArrayBuffer | undefined> {
    try {
        return (
            await axios.get(
                `/api/tic/company/${companyId}/financial-documents/${summaryId}/file/${fileId}`,
                { responseType: 'arraybuffer' },
            )
        ).data;
    } catch (error) {
        return undefined;
    }
}

export async function getSNI(): Promise<any | null> {
    try {
        return (await axios.get(`/api/resources/sni`)).data;
    } catch (error) {
        return null;
    }
}

export async function uploadSie(formData: any): Promise<any> {
    return axios.post('/api/user/sie', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}

export async function uploadBlob(formData: any): Promise<any> {
    return axios.post('/api/user/blob', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}

export async function updateSie(sie: any): Promise<any> {
    return axios.put('/api/user/sie', sie);
}

export async function addDocument(document: any): Promise<any> {
    return axios.post('/api/user/document', document);
}

export async function updateDocument(document: any): Promise<any> {
    return axios.put('/api/user/document', document);
}

export async function shareDocument(document: any): Promise<any> {
    return axios.post(`/api/user/document/share`, document);
}

export async function unshareDocument(document: any): Promise<any> {
    return axios.post(`/api/user/document/unshare`, document);
}

export async function shareDocumentLink(document: any): Promise<any> {
    return axios.post(`/api/user/document/shareLink`, document);
}

export async function unshareDocumentLink(document: any): Promise<any> {
    return axios.post(`/api/user/document/unshareLink`, document);
}

export async function isDocumentLinkShared(documentId: any): Promise<any> {
    return axios.get(`/api/user/document/getLink/${documentId}`);
}

export function sleep(ms = 0) {
    return new Promise((r) => setTimeout(r, ms));
}
